import { GA4Event} from "./GA4Event";

export function buildBookNotFoundContinueToBox(message) {
	const { attributes } = message;
	const { eventData } = new GA4Event("book_not_found_continue_to_box", {
		interaction: attributes.interaction || '',
		currency: attributes.currency || '',
		component: attributes.component || '',
		versandbox_id: attributes.versandbox_id || '',
	});
	return eventData;
}
